import { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";

import { InputButton } from "../../../components/input-button/InputButton";
import { InputPin } from "../../../components/input-pin/InputPin";

interface CreatePinProps {
  pinLength: number;
  callback: (pin: string) => void;
}

export const useStyles = makeStyles(
  (theme) => ({
    contentInner: {
      margin: "0 auto",
      width: "60%",
    },
  }),
  {
    name: "create-pin-style",
    flip: null,
  }
);

export const CreatePin = (props: CreatePinProps) => {
  const classes = useStyles(props);
  const intl = useIntl();
  // Props
  const { pinLength, callback } = props;
  // State
  const [pin, setPin] = useState("");

  const handlePinChange = (pin: string) => {
    setPin(pin);
  };

  const handleAction = () => {
    if (pin.length === pinLength) {
      callback(pin);
    }
  };

  return (
    <>
      <Box
        marginBottom={1}
        component="span"
        className="title"
        textAlign="center"
      >
        {intl.formatMessage(
          { id: "sharedScreen.createNDigitPinCode" },
          { digit: pinLength }
        )}
      </Box>
      <Box component="div" display="flex" justifyContent="center">
        <Box
          component="span"
          className="subTitle"
          width="80%"
          textAlign="center"
        >
          <FormattedMessage id="sharedScreen.createNDigitPinNotice" />
        </Box>
      </Box>

      <Box component="div" mt={6}>
        <Box className={classes.contentInner} component="div">
          <InputPin
            pinLength={pinLength}
            pin={pin}
            onPinChange={handlePinChange}
          />

          <Box marginTop={3}>
            <InputButton
              color="secondary"
              fullWidth
              size="medium"
              variant="contained"
              disabled={pin.length !== pinLength}
              onClick={(_) => handleAction()}
            >
              <FormattedMessage id="sharedScreen.next" />
            </InputButton>
          </Box>
        </Box>
      </Box>
    </>
  );
};
